import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getShippingTermList(params) {
  return request({
    url: URL.mdm.basicData.shippingTerm,
    method: 'get',
    params
  })
}

export function getShippingTermsByPlatform(params) {
  return request({
    url: URL.mdm.basicData.platformShippingTerm,
    method: 'get',
    params
  })
}

export function getAllShippingTermTemplate(params) {
  return request({
    url: URL.mdm.basicData.shippingTermTemplate,
    method: 'get',
    params
  })
}

export function saveShippingTerm(data) {
  return request({
    url: URL.mdm.basicData.shippingTerm,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function addShippingTermByPlatform(data) {
  return request({
    url: URL.mdm.basicData.platformShippingTerm,
    method: 'post',
    data
  })
}

export function saveShippingTerms(data) {
  return request({
    url: URL.mdm.basicData.shippingTerms,
    method: 'post',
    data
  })
}

export function delShippingTerm(uuid) {
  return request({
    url: URL.mdm.basicData.shippingTerm + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
